import React from 'react';
import { Route, IndexRoute, IndexRedirect } from 'react-router';

import Main from './Main';
import Mail from './Main/Mail';
import MailThreadsList from './Main/Mail/MailThreadsList';
import More from './Main/More';
import UserGoals from './Main/UserGoals';
import Links from './Main/Links';
import UserSettings from './Main/UserSettings';
import Interests from './Main/Interests';
import Referral from './Main/Referral';
import Journal from './Main/Journal';
import Feedback from './Main/Feedback';
import Search from './Main/Search';
import NotFound from 'components/NotFound';

let Feed;
Feed = require('./Main/Feed').default;

let MailThreadMessagesList, MailTeamMessageEditor;
MailThreadMessagesList = require('./Main/Mail/MailThreadMessagesList').default;
MailTeamMessageEditor = require('./Main/Mail/MailTeamMessageEditor').default;

let ChatResources;
ChatResources = require('./Main/ChatResources').default;

let UserSettingsChangeAvatar;
UserSettingsChangeAvatar = require('./Main/UserSettings/UserSettingsChangeAvatar').default;

let Forum, ForumFilteredThreadsList, ForumCategories, ForumThreadProfile, ForumContribute;
Forum = require('./Main/Forum').default;
ForumFilteredThreadsList = require('./Main/Forum/ForumFilteredThreadsList').default;
ForumCategories = require('./Main/Forum/ForumCategories').default;
ForumThreadProfile = require('./Main/Forum/ForumThreadProfile').default;
ForumContribute = require('./Main/Forum/ForumContribute').default;

let ForumLiveThreadsList, ForumLiveThreadLobby;
ForumLiveThreadsList = require('./Main/Forum/ForumLiveThreadsList').default;
ForumLiveThreadLobby = require('./Main/Forum/ForumLiveThreadLobby').default;

let ForumAskKooth;
ForumAskKooth = require('./Main/Forum/ForumAskKooth').default;

let Magazine, MagazineArticleProfile, MagazineArticlesList, MagazineCategories, MagazineContribute;
Magazine = require('./Main/Magazine').default;
MagazineArticleProfile = require('./Main/Magazine/MagazineArticleProfile').default;
MagazineArticlesList = require( './Main/Magazine/MagazineArticlesList').default;
MagazineCategories = require('./Main/Magazine/MagazineCategories').default;
MagazineContribute = require('./Main/Magazine/MagazineContribute').default;


// If feed is disabled, the magazine should be the homepage
const isMagazineHomepage = Feed === undefined;
const isMailOrChatEnabled = ChatResources !== undefined || MailThreadMessagesList !== undefined;

export default (
  <Route path="/" component={Main}>
    {Feed && <IndexRoute component={Feed} />}

    {isMagazineHomepage && <IndexRedirect to="magazine" />}
    {Magazine &&
      <Route path="magazine" component={Magazine}>
        <IndexRoute component={MagazineArticlesList} />

        <Route path="articles/:id" component={MagazineArticleProfile} />
        <Route path="articles/:id/comments" component={MagazineArticleProfile} />
        <Route path="articles/:id/comments/:commentsPage/:commentId" component={MagazineArticleProfile} />
        <Route path="articles/:id/comments/:commentsPage/:commentId/:repliesPage/:replyId" component={MagazineArticleProfile} />

        <Route path="categories" component={MagazineCategories} />
        <Route path="contribute" component={MagazineContribute} />
      </Route>
    }

    {/* Mail and Chat are on the same page */}
    {isMailOrChatEnabled &&
      <Route path="messages" component={Mail}>
        <IndexRoute component={MailThreadsList} />

        {MailThreadMessagesList && <Route path="threads/:id" component={MailThreadMessagesList} />}
        {MailTeamMessageEditor && <Route path="new" component={MailTeamMessageEditor} />}
      </Route>
    }

    {ChatResources && <Route path="chat-resources" component={ChatResources} />}

    {Forum &&
      <Route path="forum" component={Forum}>
        <IndexRoute component={ForumFilteredThreadsList} />

        <Route path="threads/:id" component={ForumThreadProfile} />
        <Route path="threads/:id/comments" component={ForumThreadProfile} />
        <Route path="threads/:id/comments/:commentsPage/:commentId" component={ForumThreadProfile} />
        <Route path="threads/:id/comments/:commentsPage/:commentId/:repliesPage/:replyId" component={ForumThreadProfile} />

        <Route path="categories" component={ForumCategories} />
        <Route path="start-discussion" component={ForumContribute} />
        {ForumAskKooth && <Route path="ask-kooth" component={ForumAskKooth} />}
        {ForumLiveThreadsList && <Route path="live" component={ForumLiveThreadsList} />}
        {ForumLiveThreadLobby && <Route path="lobby/:id" component={ForumLiveThreadLobby} />}
      </Route>
    }

    <Route path="more" component={More} />
    <Route path="search" component={Search} />
    <Route path="goals" component={UserGoals} />
    <Route path="links" component={Links} />
    <Route path="interests" component={Interests} />
    <Route path="journal" component={Journal} />
    <Route path="feedback" component={Feedback} />

    <Route path="settings">
      <IndexRoute component={UserSettings} />
      {UserSettingsChangeAvatar && <Route path="avatar" component={UserSettingsChangeAvatar} />}
    </Route>

    <Route path="referral" component={Referral} />

    <Route path="*" component={NotFound} />
  </Route>
);



/** WEBPACK FOOTER **
 ** ./src/members/routes.js
 **/